import { SimplePage } from "@/app/_/marketing/SimplePage";
import { SliceAndDiceFeature } from "@/app/_/sections/3FeaturesSection/SliceAndDiceFeature";
import { Navigation } from "@/constants";

export default function Page() {
  return (
    <SimplePage
      eyebrow="Reports & dashboards"
      title="A dashboard is worth a thousand rows."
      subtitle="Build saved views with KPI strips, P&L charts, balance sheet trees, cash flow breakdowns, and more. Slice and filter your ledger data the way your team actually thinks about it."
      secondaryCta={{
        label: "See a live report",
        to: Navigation.ROUTES.AUTH.WAITLIST,
      }}
      screenshot={{
        imageName: "reports-dashboard",
        alt: "A dashboard with KPIs, cash flow, and bank balances",
      }}
      capabilities={[
        {
          title: "Numbers that stay live.",
          description:
            "Income, expenses, cash flow, and balances recalculate as transactions are booked — no exports, no refresh.",
          imageName: "crop-report-widgets",
        },
        {
          title: "Build it from sources.",
          description:
            "Drop in P&L, balance sheet, spending by category, who-owes-what, and more. Resize and arrange them per breakpoint.",
          imageName: "component-report-widget",
        },
        {
          title: "A chart of accounts you control.",
          description:
            "Every report rolls up the same account tree, so the dashboard and the books never disagree.",
          imageName: "crop-coa-tree",
        },
      ]}
      illustration={{
        title: "Slice and dice.",
        description:
          "Filter by date, frequency, and entity, and every widget on the page follows.",
        render: () => SliceAndDiceFeature().center.renderChildren(),
      }}
      bullets={Navigation.PLATFORM_ITEMS.filter((item) =>
        ["/platform/ledger", "/platform/multi-entity"].includes(item.path),
      ).map((item) => ({
        ReactIcon: item.ReactIcon,
        name: item.name,
        tagline: item.tagline,
        to: item.path,
      }))}
    />
  );
}
